import { noop } from "lodash";
import moment from "moment";
import { createContext } from "react";
import { BaseClientFields } from "src/api/fragments";
import { MonthlyDataPoint, TaxYearBracket } from "src/api/generated/types";

const CURRENT_YEAR = moment().year();

export type FullServiceContext = {
  defaultTaxYear: string;
  year: TaxYearBracket;
  client: BaseClientFields | null;
  monthlyPoints: MonthlyDataPoint[];
  setYear: (year: string) => void;
};

export const getStartingYearBracket = () => {
  return {
    end: moment().endOf("year").toDate(),
    endFormatted: moment().endOf("year").format("YYYY-MM-DD"),
    start: moment().startOf("year").toDate(),
    startFormatted: moment().startOf("year").format("YYYY-MM-DD"),
    taxYear: CURRENT_YEAR.toString(),
  };
};

const startingYearBracket = getStartingYearBracket();

export const FullServiceContext = createContext<FullServiceContext>({
  defaultTaxYear: startingYearBracket.taxYear,
  year: startingYearBracket,
  client: null,
  monthlyPoints: [],
  setYear: noop,
});
